<template>
  <div class="col col-md-6 screen-height pr-2">
    <div id="photodoku">
      <div v-if="$route.params.reportId && $route.params.reportId !== '0'" class="innerdoc ">
        <div class="col-md-12">
          <div class="row">
          <div class="col-md-6 text-left">
            <span >
              <img :src="logoOne" class="mb-2 img-fluid logo-images-in-docs" alt="img">
            </span>
          </div>
          <div class="col-md-6 text-right">
            <span>
              <img :src="logoTwo" class="mb-2 img-fluid logo-images-in-docs" alt="img">
            </span>
          </div>
          </div>
        </div>

        <div class="col-md-12">
        <h2 class="text-center mt-3">
          <span v-if="report.constructionreport.reporttype ==='W'">WOCHENBERICHT</span>
          <span v-else>TAGESBERICHT</span>
        </h2>
        <div class="clearfix"></div>

        <div class="mb-4 mt-2">
          <div class="row project-info">
            <div class="col-md-3"><b>Bericht-Nr : </b></div>
            <div class="col-md-8 font">
              <strong>{{report.constructionreport.runid}} /  Rev : {{report.constructionreport.revision}}    </strong>
              <strong class="pl-2"><span v-show="report.constructionreport.reporttype==='W'">{{ formatDate(report.constructionreport.reportstartdate) }} - </span>{{ formatDate(report.constructionreport.crdate)}}</strong>
            </div>
            <div class="col-md-3 font mb-1">Projektname : </div>
            <div class="col-md-8 font mb-1 ">{{ project.name }}</div>
            <div class="col-md-3 font pr-0 mb-1" v-if="report.constructionreport.reportparams.show_projectnumber">Projektnummer : </div>
            <div class="col-md-2 font mb-1" v-if="report.constructionreport.reportparams.show_projectnumber">{{project.number}}</div>
            <div class="col-md-auto font mb-1" v-if="report.constructionreport.reportparams.show_constructor">Bauherr : {{project.constructor}} </div>
            <div class="col-sm-12">
              <div class="row">
                <div class="col-md-3 font pr-0" v-if="report.constructionreport.reportparams.show_creator">Berichtersteller : </div>
                <div class="col-md-9 font" v-if="report.constructionreport.reportparams.show_creator"> {{ currentuser.firstname }} {{ currentuser.lastname }}</div>
              </div>
            </div>
          </div>
        </div>
        </div>
        <div class="wetterinfo mb-3">
          <h5 class="mb-1"><b>Wetter</b></h5>
          <div class="weticons mb-2">
            <a  v-if="report.weather.weather_sunny">
              <img src="@/assets/images/weather_sunny.png" width="43" alt="sunny">
            </a>
            <a v-if="report.weather.weather_covered">
              <img src="@/assets/images/weather_sunnytocloudy.png" width="43" alt="cover">
            </a>
            <a v-if="report.weather.weather_cloudy">
              <img src="@/assets/images/weather_cloudy.png" alt="cloudy" width="43">
            </a>
            <a v-if="report.weather.weather_rain">
              <img src="@/assets/images/weather_rain.png" alt="rain" width="43">
            </a>
            <a v-if="report.weather.weather_storm">
              <img src="@/assets/images/weather_storm.png" alt="strom" width="43">
            </a>
              <a v-if="report.weather.weather_snow">
                <img src="@/assets/images/weather_snow.png" alt="snow" width="43">
              </a>
            <a v-if="report.weather.weather_thunderstorm">
              <img src="@/assets/images/weather_thunder.png" alt="strom" width="43">
            </a>
          </div>
          <div class="wetinfo mt-3">
            <div class="form-row">
              <div class="col-md-3 mb-1">
                <label class="mb-1">Temperatur Min : </label>
                <div class="border text-center">
                {{report.weather.temperature_min}} &#8451
              </div>
              </div>
              <div class="col-md-3">
               <label class="mb-1">Temperatur Max :</label>
               <div class="border text-center">
                {{report.weather.temperature_max}} &#8451
              </div>
              </div>
              <div class="col-md-3">
               <label class="mb-1">Windstärke :</label>
                <div class="border text-center">
                {{report.weather.windspeed}} Km/h</div>
              </div>
              <div class="col-md-3">
                <label class="mb-1">Hydro :</label>
                <div class="border text-center">
                {{report.weather.humidity}} 	&#37;
              </div>
              </div>

            </div>
            <p class="mt-2 pb-2">Sonstige Wetterbemerkungen : </p>
            <input class="form-control bg-white text-left text-dark" type="text" :value="report.weather.misc" readonly>
          </div>
        </div>

        <div class="personalinfo mb-3">
          <h4><b>Personal</b> </h4>
          <div class="table-responsive mt-4" v-for="shift in report.staff.shifts">

            <div class=" m-0 row">
              <div class="col-md-3 pl-0">
                <h4> {{shift.crshiftname}} </h4>
              </div>
              <div class="col-md-9 pl-0">
                <label class="font16">Start : </label>
                <div class="badge font16 badge-info">{{ shift.start }}</div>
                <label  class="font16">End : </label>
                <div class="badge font16 badge-info"> {{ shift.end }}</div>
              </div>
            </div>

            <table class="table tblinfo tblprsnl">
              <tr>
                <th>Firma</th>
                <th v-for="shiftType in shift.stafftypes">{{shiftType.stafftypename}}</th>
              </tr>
              <tr v-for="(shiftValues, index) in shift.stafftypes[0].workingvalues">
                <td>{{shiftValues.companyname}}</td>
                <td v-for="(type, i) in shift.stafftypes">
                  <span> {{type.workingvalues[index].workingvalue}}</span>
                </td>
              </tr>
            </table>
          </div>
        </div>


        <div class="pt-3  pb-4 mb-3 border-top mt-3 col-md-12" v-for="group in report.groups">
          <h5 class="mb-2"><b>{{group.crgroupname}}</b></h5>
          <div v-for="val in group.groupvalues">
          <p class="mt-3 mb-1">{{val.crgroupfieldname}}</p>
          <div class="col-md-12 pl-0">
           <div class="p-2 border bg-white rounded font13 text-dark" style="min-height: 4rem">
             {{val.crgroupfieldvalue}}
           </div>
          </div>
          </div>
        </div>

        <div class="col-md-12 simple-photos section-images" v-if="selectedPhotos && selectedPhotos.length > 0">
          <h4 class="font-weight-bold text-secondary mb-3"> Angefügte Fotos </h4>
          <div class="row" v-for="photo in selectedPhotos" :key="photo.pdphotoid">
            <div class="col-md-5 mb-3 img-fluid">
              <div data-aspect-ratio="4:3">
                <div class="rounded rounded-lg pr-3" :style="{'background-image': 'url(\'' + getImagePath(photo.pdphotoid) + '\')'}"></div>
                <div class="simple-photo-option mw-100 photo mb-0">
                  <ul class="text-center">
                    <li class="pl-2">Nr.{{photo.runid}}</li>
                    <li>|</li>
                    <li>{{photo.photodate | setDate}}  </li>
                    <li>|</li>
                    <li class="pr-2">{{photo.photodate | setTime}} Uhr</li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-md-7 form-group mb-1">
              <label class="font-weight-bold text-secondary">Beschreibung</label>
              <div class="p-2 border bg-white rounded font13 text-dark h-75">
                {{photo.descriptionextend}}
              </div>
            </div>
          </div>
        </div>

<!--        <div class="col-md-12 text-center">-->
<!--          <button  type="button" class="btn btn-danger" @click="$router.push({ name: 'constructionDocs',params:{ id: $route.params.id }})">-->
<!--            Abbrechen-->
<!--          </button>-->
<!--&lt;!&ndash;          <button type="button" class="btn bg-blue btn-blue">&ndash;&gt;-->
<!--&lt;!&ndash;            Speichem&ndash;&gt;-->
<!--&lt;!&ndash;          </button>&ndash;&gt;-->
<!--        </div>-->

        <div class="col-sm-12">
          <div class="row">
            <div class="col-sm-4">
              <div style="width:100%; height:45px; border:1px solid #ced4da; padding: 0px 4px;" v-if="report.constructionreport.reportparams.left_footer !== false">
                <small style="padding:0; margin:0;">Erstellt durch:</small>
                <p>{{left_footer_report_text}}</p>

              </div>
            </div>
            <div class="col-sm-4">
              <div style="width:100%; height:45px; border:1px solid #ced4da; padding: 0px 4px;" v-if="report.constructionreport.reportparams.center_footer !== false">
                <small style="padding:0; margin:0;">geprüft AN:</small>
                <p v-if="report.constructionreport.reportparams.center_footer !== false">{{center_footer_text}}</p>
              </div>
            </div>
            <div class="col-sm-4">
              <div style="width:100%; height:45px; border:1px solid #ced4da; padding: 0px 4px;" v-if="report.constructionreport.reportparams.right_footer !== false">
                <small style="padding:0; margin:0;">gesehen AG:</small>
                <p v-if="report.constructionreport.reportparams.right_footer !== false">{{right_footer_text}}</p>
              </div>
            </div>

          </div>
        </div>


        <p class="text-center border-top pt-3 mx-3 mt-1 pb-3">
          <span class="float-left">{{ report.constructionreport.runid }} / Rev {{report.constructionreport.revision}} &nbsp; &nbsp; &nbsp; {{ formatDate(report.constructionreport.crdate) }} </span>
          <span class="float-right">projectdocu.com</span>
        </p>
      </div>
      <div v-else class="col-md-12 mt-4">
        <h2 class="text-center">Kein Bautagebuch vorhanden</h2>
      </div>
    </div>

  </div>
</template>
<script>
import {mapState} from 'vuex'
import {formatDate, formatTimeUhr} from '../../common'
export default {
  created () {
    if (this.$route.params.reportId && this.$route.params.reportId !== '0'){
      this.$store.dispatch("getConstructionReportById", {id: this.$route.params.reportId,isEdit: false})
    }
    if (this.logoOne === '' || !this.logoTwo){
      this.$store.dispatch("getProjectDetails",this.$route.params.id)
    }
  },
  filters: {
    setDate: (date) => formatDate(date),
    setTime: (date) => formatTimeUhr(date)
  },
  computed: {
    ...mapState({
      report: state => state.constructionDiary.reportDetails,
      project: state => state.appSettings.project,
      logoOne: state => state.appSettings.logoOne,
      selectedPhotos: state => state.constructionDiary.selected_report_photos,
      logoTwo: state => state.appSettings.logoTwo,
      projectImg: state => state.appSettings.projectImage,
    }),
    left_footer_report_text: {
      get() {
        if(this.report.constructionreport.reportparams.left_footer == '%currentuser%') {
          return this.currentuser.firstname + ' ' + this.currentuser.lastname
        }
        if(this.report.constructionreport.reportparams.left_footer != false) {
          if(typeof this.report.constructionreport.reportparams.left_footer == "boolean" ) {
            return ''
          }
          return this.report.constructionreport.reportparams.left_footer
        }
        return ''
      },
      set() {

      }
    },

    center_footer_text: {
      get() {
        if(typeof this.report.constructionreport.reportparams.center_footer === "boolean") {
          return '';
        }
        return this.report.constructionreport.reportparams.center_footer
      },
      set(newValue) {
        this.report.constructionreport.reportparams.center_footer = newValue
      }
    },

    right_footer_text: {
      get() {
        if(typeof this.report.constructionreport.reportparams.right_footer === "boolean") {
          return '';
        }
        return this.report.constructionreport.reportparams.right_footer
      },
      set(newValue) {
        this.report.constructionreport.reportparams.right_footer = newValue
      }
    },
  },
  methods: {
    getImagePath(photo_id) {
      const project_id = this.$route.params.id
      return `${process.env.VUE_APP_GET_METHOD_URL}img&projectid=${project_id}&id=${photo_id}&token=${localStorage.sessiontoken}&PHPSESSID=${localStorage.sessiontoken}`
    },
    formatDate: (date)=> formatDate(date)
  },
  watch:{
    '$route.params.reportId': function (){
      this.$store.dispatch("getConstructionReportById",{id: this.$route.params.reportId,isEdit: true})
    }
  }
}
</script>
<style scoped>
.project-info .font{
  font-size: 1rem !important;
}
.font16{
  font-size: 0.97rem;
  font-weight: normal;
}
.col-md-12 article{
  min-height: 4rem;
}
#photodoku{
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/constructionDiary/components/ConstructionDiaryPreview.vue